import { Box, DialogActions } from "@mui/material"
import { OpenInNewOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { Button } from "@/components/common/Button"

interface SendDialogActionsProps {
  submitLabel: string
  isValid: boolean
  isSubmitted: boolean
  isPreviewFetching?: boolean
  onCancel: () => void
  onPreview: () => void
  onSubmit: () => void
}

export const SendDialogActions: FC<SendDialogActionsProps> = ({
  submitLabel,
  isValid,
  isSubmitted,
  isPreviewFetching = false,
  onCancel,
  onPreview,
  onSubmit,
}) => {
  return (
    <DialogActions className='justify-between px-10 pb-10'>
      <Button appearance='outlined' onClick={onCancel}>
        Cancel
      </Button>
      <Box className='flex justify-between gap-3'>
        <Button
          disabled={!isValid || isPreviewFetching}
          appearance='outlined'
          endIcon={<OpenInNewOutlined />}
          onClick={onPreview}
        >
          Preview PDF
        </Button>
        <Button disabled={!isValid || isSubmitted} onClick={onSubmit}>
          {submitLabel}
        </Button>
      </Box>
    </DialogActions>
  )
}
